import { render } from "./shiftSelectDialog.vue?vue&type=template&id=5628d250&scoped=true"
import script from "./shiftSelectDialog.vue?vue&type=script&lang=js"
export * from "./shiftSelectDialog.vue?vue&type=script&lang=js"

import "./shiftSelectDialog.vue?vue&type=style&index=0&id=5628d250&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5628d250"]])

export default __exports__